import { Component, Input } from '@angular/core';

import { CustomButtonComponent } from '../custom-button/custom-button.component';

@Component({
    selector: 'app-star-button',
    templateUrl: './star-button.component.html',
    styleUrls: ['./star-button.component.scss'],
    standalone: true,
    imports: [CustomButtonComponent]
})
export class StarButtonComponent {
  @Input() canStar = false;
  @Input() isStarred = false;
  @Input() onToggle: (() => void) | undefined;

  public toggle() {
    if (this.onToggle) {
      this.onToggle();
    }
  }
}
